import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../../contexts";
import ContextButton from "../../Helpers/ContextButton";
import LinksUploader from "../MultiFile/LinksUploader";
import { useDropzone } from "react-dropzone";
import Popup from "../../Helpers/Popup";
import humanFileSize from "../../../utils/humanFileSize";

function SingleBig(props) {
  const store = useLocalObservable(() => ({
    show_links_uploader:false,
    drag_over:false,
  }));
  const compStore=useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  const {getRootProps, getInputProps, isDragActive, open} = useDropzone({
    ...compStore.options.uploadOptions,
    onDrop:(files)=>{
      if(files.length) {
        runInAction(()=>{
          compStore.data.uploading_file = files[0]
          store.drag_over=false;
        });
        compStore.startUpload();
      }
    },
    onDragLeave:()=>{
      runInAction(()=>{ store.drag_over=false; });
    },
    onDragEnter:()=>{
      runInAction(()=>{ store.drag_over=true; });
    },
    noClick:true,
    noKeyboard:true
  });

  const getFile=()=>{
    return compStore.data.tmp_file || compStore.data;
  };
  const getSrc=()=>{
    return getFile().preview_big || null;
  };


  return (
    <div>
      <Popup disablePaddings={true} showed={true} onHide={()=>{ props.onClose(); }}>
        <div style={{width: 420, height: 400}}  className="pr " {...getRootProps()}>
          <input {...getInputProps()}/>
          <div className="up12 splice solid1-bottom bo-w2" style={{height:50}}>
            <div className="cell s-shrink s-middle pr">
              <span className="dib hpadd10 vpadd10 pointer" onClick={(e)=>{ e.stopPropagation(); e.preventDefault(); open(e); }}>
                <span className="mdi mdi-file-replace-outline fs20 vam"></span>
                <span className="pleft5">Заменить файл</span>
              </span>
              <ContextButton items={[
                  {title:"Загрузить по ссылке", onClick:()=>{ store.show_links_uploader=true; }},
                  {title:"Удалить", onClick:()=>{ compStore.data.delete=true;  compStore.setMarkFileWas(); }},
                ]}>{(ret)=>{
                  return (
                    <span className="dib vam pr">
                      <span {...ret.buttonProps} className="mdi pointer mdi-dots-vertical dib vam fs24"></span>
                      {ret.Context}
                    </span>
                  )
                }}
              </ContextButton>
              {store.show_links_uploader?(
                <div className="pa pa-tl bg-w1 padd5 shadow z4">
                  <LinksUploader replace={true} single={true} onClose={(scroll)=>{ runInAction(()=>{ store.show_links_uploader=false;  }); }} />
                </div>
              ):null}
            </div>
            <div className="cell s-auto fs17 bold s-middle tac vpadd10">
              Файл
            </div>
            <div className="cell s-shrink tar s-middle">
              <span className="dib hpadd10 vpadd10 pointer" onClick={()=>{ props.onClose(); }}>
                <span className="mdi mdi-close fs20 vam"></span>
                <span className="pleft5">Закрыть</span>
              </span>
            </div>
          </div>

          <div style={{height: 349}} className="bg-w2-op50 pr">
            {getSrc()?(
              <div className="ptop20 pbottom10">
                <img src={getSrc()} className="w100 of-scale-down db" style={{ height:245 }} />
              </div>
            ):(
              <div style={{height:245}} className="ptop25">
                <div className=" b1 fs12 lh14 tac ptop20 ofh ttu bold center mtop10 pr " style={{backgroundColor: getFile().color, height:60*3, width: 45*3}}>
                  <div className="pa pa-tr bg-w2" style={{borderColor:`#F8F8F8 #F8F8F8 #ffffff #ffffff`, borderWidth:10*3, borderStyle:"solid"}}></div>
                  <div style={{fontSize:`${12*4}px`}} className="pa lh12 pa-bl  bold w1 pleft5 pbottom2">{getFile().ext}</div>
                </div>
              </div>
            )}
            <div className="ptop10 hpadd15">
              <div className="up12 margin">
                <div className="cell s-auto" style={{wordBreak:"break-word"}}>
                  <a target="_blank" href={getFile().public_url} className="clear b1 tdni">{getFile().file_name} <span className="mdi mdi-open-in-new fs18 dib vam pc1"></span></a>
                </div>
                <div className="cell s-shrink wsnw">
                  <span className="w5">{humanFileSize(getFile().file_size)}</span>
                  {getFile().width + getFile().height > 0?(
                    <span className="w5 pleft10">{getFile().width}&times;{getFile().height}</span>
                  ):null}
                </div>
              </div>
            </div>

            {compStore.data.delete?(
              <div className="pa pa-tl w100 h100 bg-w1-op20 up12 splice z2">
                <div className="cell s-12 tac s-middle">
                  <span className="const1">Фото будет удалено при сохранении</span>
                  <div className="ptop20">
                    <span onClick={()=>{
                      runInAction(()=>{
                        delete compStore.data.delete;
                      });
                    }} className="btn9 tac pr z4"><span><span className="mdi mdi-delete-restore "></span> Отменить удаление</span></span>
                  </div>
                </div>
              </div>
            ):null}

          </div>

          {store.drag_over?(
            <div className="pa pa-tl w100 h100 dashed1 rad4 bg-w1">
              <div className="up12 splice h100">
                <div className="cell s-12 tac s-middle fs16">
                  Бросайте файл сюда, чтоб заменить файл
                </div>
              </div>
            </div>
          ):null}
          {compStore.cur_progress.active ? (
            <div className="pa pa-tl w100 h100 bg-w1 z4 dashed1 bo-w3 rad3">
              <div className="up12 splice h100 s-center">
                <div className="cell s-10 tac s-middle tac">
                  <div className="ptop2 rad4 ofh bg-w3 pr">
                    <div className="pa pa-tl h100 bg-pc1" style={{width: `${compStore.cur_progress.percent}%`}}></div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

        </div>
      </Popup>
    </div>
  )
};

SingleBig.defaultProps = {};

SingleBig.propTypes = {}

export default observer(SingleBig);
